import getStaleFlightUpdateStore from "./store";

export function isStaleFlightUpdateAvailable(): boolean {
    return getStaleFlightUpdateStore().isUpdateAvailable;
}

export function getStaleFlightUpdateEnabledChangeCount(): number {
    return getStaleFlightUpdateStore().enabledChangeCount;
}

export function getStaleFlightUpdateDisabledChangeCount(): number {
    return getStaleFlightUpdateStore().disabledChangeCount;
}

export function getStaleFlightUpdateDetectedAt(): number {
    return getStaleFlightUpdateStore().detectedAt;
}
